"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import dynamic from "next/dynamic";
const Tabs = dynamic(() => import("antd/es/tabs"), { ssr: false });
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { FaCirclePlay } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
import BasicSummary from "./tab-content/BasicSummary";
import Syllabus from "./tab-content/Syllabus";
import Routine from "./tab-content/Routine";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import { useRouter } from "next/navigation";
import CourseService from "@/services/api/CourseService";
const Modal = dynamic(() => import("antd/es/modal"), { ssr: false });
import { ToastContainer, toast } from "react-toastify";

export default function CourseDetailSection({ course }) {
  // console.log("course", course);
  const [isPlaying, setIsPlaying] = useState(false);
  const userInfo = useSelector((state) => state.user.userInfo);
  const dispatch = useDispatch();
  const router = useRouter();

  const handleFreeTrial = async () => {
    const payload = {
      course_id: course.id,
    };

    try {
      const response = await CourseService.courseFreeEnroll(payload);
      if (response) {
        toast.success("ফ্রি ট্রায়াল সফলভাবে গ্রহণ করা হয়েছে!");
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error(
          "⚠️ কোর্সে ইনরোল করতে একটি ত্রুটি ঘটেছে। অনুগ্রহ করে কর্তৃপক্ষের সাথে যোগাযোগ করুন।"
        );
      }
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/admission-icon/at-a-galance.png"
            alt="Price Tag"
            width={24}
            height={24}
          />
          এক নজরে
        </span>
      ),
      children: <BasicSummary course={course} />,
    },
    {
      key: "2",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/admission-icon/syllabus-icon.png"
            alt="Price Tag"
            width={24}
            height={24}
          />
          কোর্স সিলেবাস
        </span>
      ),
      children: <Syllabus course={course} />,
    },
    {
      key: "3",
      label: (
        <span className="course_tab_nav">
          <Image
            src="/images/admission-icon/calender-icon.png"
            alt="Price Tag"
            width={24}
            height={24}
          />
          ক্লাস রুটিন
        </span>
      ),
      children: <Routine course={course} />,
    },
  ];

  return (
    <>
      <div className="course-details-section section_padding">
        <div className="container">
          <div className="content">
            <div className="grid grid-cols-12 gap-6">
              <div className="xl:col-span-4 lg:col-span-5 col-span-12">
                <div className="course-details-card-wrap">
                  <div className="course-thumbnail">
                    {!isPlaying ? (
                      <>
                        <div className="image-wrap relative">
                          <Image
                            src={
                              course?.thumbnail ??
                              "/images/course/thumbnail-1.avif"
                            }
                            alt="course thumbnail"
                            className="hero-img"
                            fill
                          />
                        </div>
                        <div className="hero-image-playbtn">
                          {/* test icon */}
                          <div
                            className="hero-play will-change-transform animate-[spin_10s_linear_infinite]"
                            onClick={() => setIsPlaying(true)}
                          >
                            <div className="hero-play-container ">
                              <div className="text-wrap circle-text absolute inset-1 origin-center  pointer-events-none">
                                <svg
                                  viewBox="0 0 200 200"
                                  className="w-full h-full -rotate-90"
                                >
                                  <defs>
                                    <path
                                      id="circlePath"
                                      d="M100,100 m-75,0 a75,75 0 1,1 150,0 a75,75 0 1,1 -150,0"
                                    />
                                  </defs>
                                  <text className="fill-white uppercase tracking-[6px] text-[20px] select-none font-poppins">
                                    <textPath xlinkHref="#circlePath">
                                      • WATCH VIDEO • WATCH VIDEO
                                    </textPath>
                                  </text>
                                </svg>
                              </div>

                              <div className="absolute inset-0 grid place-items-center">
                                <div className="icon-wrap">
                                  <FaPlay
                                    className="play-icon"
                                    onClick={() => setIsPlaying(true)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* test icon */}
                        </div>
                      </>
                    ) : (
                      <Modal
                        open={isPlaying}
                        onCancel={() => setIsPlaying(false)}
                        footer={null}
                        centered
                        width={800}
                        className="video-modal"
                        styles={{
                          body: {
                            padding: 0,
                          },
                        }}
                        destroyOnHidden
                      >
                        <div className="aspect-video w-full">
                          <YoutubePlayer url={course?.promo_video} />
                        </div>
                      </Modal>
                    )}
                  </div>
                  {/* course price box */}
                  <div className="course-price-box">
                    {/* Box_1 */}
                    <div className="inner-box">
                      <h3 className="title">
                        <span className="price-icon">
                          <Image
                            src="/images/admission-icon/school-icon.png"
                            alt="icon"
                            width={24}
                            height={24}
                          />
                        </span>
                        <span>মোট ক্লাস</span>
                      </h3>
                      <p className="value">{course?.total_class} টি</p>
                    </div>
                    {/* Box_2 */}
                    <div className="inner-box">
                      <h3 className="title">
                        <span className="price-icon">
                          <Image
                            src="/images/admission-icon/books-icon.png"
                            alt="icon"
                            width={24}
                            height={24}
                            className="price-icon"
                          />
                        </span>
                        <span>কোর্সের সময়সীমা</span>
                      </h3>
                      <p className="value"> {course?.duration}</p>
                    </div>
                    {/* Box_3 */}
                    <div className="inner-box">
                      <h3 className="title">
                        <span className="price-icon">
                          <Image
                            src="/images/admission-icon/class-start-icon.png"
                            alt="icon"
                            width={24}
                            height={24}
                          />
                        </span>
                        <span>ক্লাস শুরু</span>
                      </h3>
                      <p className="value"> {course?.start_date}</p>
                    </div>
                    {/* Box_4 */}
                    <div className="inner-box">
                      <h3 className="title">
                        <span className="price-icon">
                          <Image
                            src="/images/admission-icon/metting-icon.png"
                            alt="icon"
                            width={24}
                            height={24}
                          />
                        </span>
                        <span>সেশন</span>
                      </h3>
                      <p className="value">{course?.session?.name}</p>
                    </div>
                    {/* Box_5 */}
                    <div className="inner-box">
                      <h3 className="title">
                        <span className="price-icon">
                          <Image
                            src="/images/admission-icon/clock-icon.png"
                            alt="icon"
                            width={24}
                            height={24}
                            className="price-icon"
                          />
                        </span>
                        <span>ইনরোলের সময়সীমা</span>
                      </h3>
                      <p className="value">
                        {course?.duration_date_range_bangla}
                      </p>
                    </div>
                    {(course?.type === "Online" ||
                      course?.type === "Online & Offline") && (
                      <div className="inner-box ">
                        <h3 className="title">
                          <span className="price-icon">
                            <Image
                              src="/images/admission-icon/price-icon.png"
                              alt="icon"
                              width={24}
                              height={24}
                            />
                          </span>
                          <span>অনলাইন কোর্স ফি</span>
                        </h3>
                        <p className="value">
                          ৳
                          {course?.discount > 0
                            ? course?.online_admission_fee -
                              (course?.discount || 0)
                            : course?.online_admission_fee ?? 0}
                          /=
                          {course?.discount > 0 && (
                            <span className="discount-price">
                              {course.online_admission_fee}৳
                            </span>
                          )}
                        </p>
                      </div>
                    )}

                    {(course?.type === "Offline" ||
                      course?.type === "Online & Offline") && (
                      <div className="inner-box ">
                        <h3 className="title">
                          <span className="price-icon">
                            <Image
                              src="/images/admission-icon/price-icon.png"
                              alt="icon"
                              width={24}
                              height={24}
                            />
                          </span>
                          <span>অফলাইন কোর্স ফি</span>
                        </h3>
                        <p className="value">
                          ৳
                          {course?.discount > 0
                            ? course?.admission_fee - (course?.discount || 0)
                            : course?.admission_fee}
                          /=
                          {course?.discount > 0 && (
                            <span className="discount-price">
                              {course.admission_fee}৳
                            </span>
                          )}
                        </p>
                      </div>
                    )}

                    <motion.div
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.4 }}
                      className="course-hero-btns space-3"
                    >
                      {(() => {
                        const onlineAction = () =>
                          userInfo
                            ? router.push(
                                `/course/${course?.slug}/checkout/online`
                              )
                            : dispatch(openDrawer("login"));

                        const offlineAction = () =>
                          userInfo
                            ? router.push(
                                `/course/${course?.slug}/checkout/ofline`
                              )
                            : dispatch(openDrawer("login"));

                        const freeAction = () =>
                          userInfo
                            ? handleFreeTrial()
                            : dispatch(openDrawer("login"));

                        if (course?.admission_fee === 0) {
                          return (
                            <>
                              <button
                                onClick={freeAction}
                                className="primary-btn cursor-pointer !w-full flex items-center justify-center py-3"
                              >
                                ফ্রি এনরোল করুন
                                <Image
                                  src="/images/admission-icon/arrow-left.png"
                                  alt="Arrow Right"
                                  className="arrow-icon ml-2"
                                  width={16}
                                  height={16}
                                />
                              </button>
                              {/* <p className="text-sm text-blue-800 mt-2 text-center">
                                <strong className="font-bold">বিঃ দ্রঃ</strong>{" "}
                                এই কোর্সটি আপনি ফ্রি ৩ দিনের ট্রায়াল হিসেবে
                                ব্যবহার করতে পারবেন
                              </p> */}
                            </>
                          );
                        }

                        return (
                          <>
                            {(() => {
                              const isOnline =
                                course?.type === "Online" ||
                                course?.type === "Online & Offline";
                              const isOffline =
                                course?.type === "Offline" ||
                                course?.type === "Online & Offline";
                              const topButtons = [isOnline, isOffline].filter(
                                Boolean
                              ).length;

                              return (
                                <>
                                  {/* যখন দুইটা বাটন থাকবে */}
                                  {topButtons === 2 && (
                                    <>
                                      <div className="flex gap-3 basis-full">
                                        {course?.payment_type == 1 && (
                                          <button
                                            onClick={onlineAction}
                                            className="btn-outline px-6 py-2 w-1/2"
                                          >
                                            অনলাইন পেমেন্ট
                                          </button>
                                        )}
                                        {course?.payment_type == 0 && (
                                          <button
                                            onClick={offlineAction}
                                            className="primary-btn flex items-center justify-center px-6 py-2 w-1/2"
                                          >
                                            অফলাইন পেমেন্ট
                                          </button>
                                        )}
                                      </div>

                                      {/* <button
                                        onClick={freeAction}
                                        className="primary-btn cursor-pointer flex items-center justify-center py-3 basis-full"
                                      >
                                        ফ্রি এনরোল করুন
                                      </button> */}
                                    </>
                                  )}

                                  {/* যখন শুধুমাত্র একটি বাটন থাকবে */}
                                  {topButtons === 1 && (
                                    <div className="flex gap-3 w-full">
                                      {isOnline &&
                                        course?.payment_type == 1 && (
                                          <button
                                            onClick={onlineAction}
                                            className="btn-outline px-6 py-2 w-1/2"
                                          >
                                            অনলাইন পেমেন্ট
                                          </button>
                                        )}
                                      {isOffline &&
                                        course?.payment_type == 0 && (
                                          <button
                                            onClick={offlineAction}
                                            className="primary-btn flex items-center justify-center px-6 py-2 w-1/2"
                                          >
                                            অফলাইন পেমেন্ট
                                          </button>
                                        )}

                                      {/* 
                                      <button
                                        onClick={freeAction}
                                        className="primary-btn flex items-center justify-center py-3 w-1/2"
                                      >
                                        ফ্রি এনরোল করুন
                                      </button> */}
                                    </div>
                                  )}

                                  {/* যখন কোনো বাটন নেই */}
                                  {/* {topButtons === 0 && (
                                    <button
                                      onClick={freeAction}
                                      className="primary-btn flex items-center justify-center py-3 basis-full"
                                    >
                                      ফ্রি এনরোল করুন
                                    </button>
                                  )} */}
                                </>
                              );
                            })()}
                          </>
                        );
                      })()}
                    </motion.div>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-8 lg:col-span-7 col-span-12">
                <div className="course-detail-tab-section">
                  <div className="fa-card">
                    <h2 className="details-main-title">
                      <span>
                        <Image
                          src="/images/admission-icon/online-course-icon.png"
                          alt="Price Tag"
                          width={24}
                          height={24}
                        />
                      </span>
                      <span>কোর্স বিস্তারিত</span>
                    </h2>
                    <Tabs
                      defaultActiveKey="1"
                      items={items}
                      className="course_tabs"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
